import axios from 'axios'

const tsRespondersPath = 'ts-responders'
const docSignersPath = 'doc-signers'
const ocspRespondersPath = 'ocsp-responders'

export default {
  // tsResponder
  async createTsResponder(tsResponderDto) {
    await axios.post(`${tsRespondersPath}`, tsResponderDto)
  },

  async updateTsResponder(name, tsResponderUpdate) {
    await axios.put(`${tsRespondersPath}/${name}`, tsResponderUpdate)
  },

  async deleteTsResponder(name, deleteKey = true) {
    await axios.delete(`${tsRespondersPath}/${name}`, {
      params: {
        'delete-key': deleteKey
      }
    })
  },

  async getTsResponder(name) {
    const resp = await axios.get(`${tsRespondersPath}/${name}`)
    return resp.data
  },

  async listTsResponders(q, pageRequest) {
    const resp = await axios.get(`${tsRespondersPath}`, {
      params: {
        q,
        ...pageRequest
      }
    })
    return resp.data
  },

  // docSigner
  async createDocSigner(docSignerDto) {
    await axios.post(`${docSignersPath}`, docSignerDto)
  },

  async updateDocSigner(name, docSignerUpdate) {
    await axios.put(`${docSignersPath}/${name}`, docSignerUpdate)
  },

  async deleteDocSigner(name, deleteKey = true) {
    await axios.delete(`${docSignersPath}/${name}`, {
      params: {
        'delete-key': deleteKey
      }
    })
  },

  async getDocSigner(name) {
    const resp = await axios.get(`${docSignersPath}/${name}`)
    return resp.data
  },

  async listDocSigners(q, pageRequest) {
    const resp = await axios.get(`${docSignersPath}`, {
      params: {
        q,
        ...pageRequest
      }
    })
    return resp.data
  },

  async generateGPGCertificatedPublicKey(name, DN) {
    const resp = await axios.get(`${docSignersPath}/${name}/gengpgpublickey/${DN}`)
    return resp.data
  },

  // ocspResponder
  async createOcspResponder(ocspResponderDto) {
    await axios.post(`${ocspRespondersPath}`, ocspResponderDto)
  },

  async updateOcspResponder(name, ocspResponderUpdate) {
    await axios.put(`${ocspRespondersPath}/${name}`, ocspResponderUpdate)
  },

  async deleteOcspResponder(name, deleteKey = true) {
    await axios.delete(`${ocspRespondersPath}/${name}`, {
      params: {
        'delete-key': deleteKey
      }
    })
  },

  async getOcspResponder(name) {
    const resp = await axios.get(`${ocspRespondersPath}/${name}`)
    return resp.data
  },

  async listOcspResponders(q, pageRequest) {
    const resp = await axios.get(`${ocspRespondersPath}`, {
      params: {
        q,
        ...pageRequest
      }
    })
    return resp.data
  }
}
